import { render, staticRenderFns } from "./user_grade_list_add.vue?vue&type=template&id=5da8d590&scoped=true&"
import script from "./user_grade_list_add.vue?vue&type=script&lang=js&"
export * from "./user_grade_list_add.vue?vue&type=script&lang=js&"
import style0 from "./user_grade_list_add.vue?vue&type=style&index=0&id=5da8d590&lang=less&scoped=true&"
import style1 from "./user_grade_list_add.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da8d590",
  null
  
)

export default component.exports